// components/profile/FormField.tsx
// ✅ ALIGNED: Uses shadcn Input and Label components
import React, { ReactNode } from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

interface FormFieldProps {
    label: string;
    id: string;
    value: string;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    placeholder?: string;
    required?: boolean;
    type?: string;
    icon?: ReactNode;
    className?: string;
    helper?: string;
    disabled?: boolean;
}

export const FormField: React.FC<FormFieldProps> = ({
                                                        label,
                                                        id,
                                                        value,
                                                        onChange,
                                                        placeholder,
                                                        required = false,
                                                        type = "text",
                                                        icon,
                                                        className = "",
                                                        helper,
                                                        disabled = false
                                                    }) => {
    return (
        <div className={className}>
            <Label htmlFor={id}>
                {label}
                {required && <span className="text-red-500 ml-1">*</span>}
            </Label>
            <div className="relative">
                <Input
                    type={type}
                    id={id}
                    name={id}
                    value={value}
                    onChange={onChange}
                    placeholder={placeholder}
                    required={required}
                    disabled={disabled}
                    className={icon ? "pr-10" : ""}
                />
                {icon && (
                    <div className="absolute right-3 top-1/2 transform -translate-y-1/2 text-muted-foreground">
                        {icon}
                    </div>
                )}
            </div>
            {helper && (
                <p className="mt-1 text-xs text-muted-foreground">{helper}</p>
            )}
        </div>
    );
};